import React, { useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { Link } from 'react-router-dom'
import slugify from 'react-slugify'
import { API_BASE_URL } from "../../api/config"


const Allblog = ({ bok }) => {

    useEffect(() => {
        // sanitize on mount
    }, [bok]) 


    return (
        <Row className="aaer-cursor my-5" >
           <Col md={3} className="img-han">
                {bok?.id && bok?.blog_title && <Link to={`/blog/${bok?.id}/${slugify(bok.blog_title)}`} >
                    <Card.Img src={`${API_BASE_URL}/${bok.blog_image}`} className="img-fluid " />
                </Link>}
            </Col> 
            <Col md={9}>
                {bok?.id && bok?.blog_title && <Link to={`/blog/${bok?.id}/${slugify(bok?.blog_title)}`} style={{ color: 'var(--text-color)', textDecoration: "none" }}>
                    <Card.Title as="h4" className=" mb-0">{bok?.blog_title}</Card.Title>
                    <div>
                        <small className="text-muted">{(new Date(bok?.created_at)).toDateString()}  |  233 Views</small>
                    </div>


                    <Card.Text className='mt-2 mb-3'>

                        {parse(DOMPurify.sanitize((bok?.blog_body?.substring(0, 200) || '') + '...', {
                            USE_PROFILES: { html: true },
                        }))
                        }

                    </Card.Text>
                    <h6 >  {(!bok?.user?.firstname && !bok?.user?.lastname) ? 'AAER' : ''} {(bok?.user?.firstname || 'AAER') + ' ' + (bok?.user?.lastname || ' ')}</h6>
                </Link>}
            </Col> 


        </Row>
    )
}

export default Allblog